import { push } from "../../../lib/gtm";
export var clickOnChatLink = function (link) {
    return link &&
        push({
            event: "navEvent",
            content_type: "Live Chat",
            content_list_type: "Navigation",
            content_title: "Help Assistant",
            content_id: link,
        });
};
export var openChatBubble = function () {
    return push({
        event: "navEvent",
        content_type: "Live Chat",
        content_list_type: "Help Assistant Popup",
        content_title: "open",
    });
};
export var closeChatBubble = function () {
    return push({
        event: "navEvent",
        content_type: "Live Chat",
        content_list_type: "Help Assistant Popup",
        content_title: "close",
    });
};
